export class CommissionDBRow {
  accountId: string;
  currency: string;
  date: number;
  source: string;
  amountInUSD: number;
  sum: number;
  spotPrice: number;
  displayName: string;
  // executionSum: number;

  // constructor(date: Date, accountId: string, currency: string, source: string) {
  //   this.date = date;
  //   this.accountId = accountId;
  //   this.currency = currency;
  //   this.source = source;
  // }

  constructor(accountId: string, displayName: string, currency: string, date: number, source: string, sum: number, amountInUSD: number) {
    this.accountId = accountId;
    this.displayName = displayName;
    this.currency = currency;
    this.date = date;
    this.source = source;
    this.sum = sum;
    this.amountInUSD = amountInUSD;
  }

  // constructor(accountId: string, currency: string, source: string, commissionSum: number) {
  //   this.accountId = accountId;
  //   this.currency = currency;
  //   this.source = source;
  //   this.commissionSum = commissionSum;
  // }
}
